export const unMapDraftData = draft => {
  const draftCopy = { ...draft };
  const personData = draftCopy.personData || {};

  const otherFunds = personData?.companyFunds?.[0]?.data?.other;
  // means other input was filled;
  if (otherFunds && typeof otherFunds === "string" && otherFunds !== "0") {
    personData.companyFunds[0].data.otherInput = otherFunds;
    personData.companyFunds[0].data.other = true;
  }

  const mainCustom = personData?.mainCustom;

  //   means some checkbox was selected but cant know which of the 2
  if (Array.isArray(mainCustom) && mainCustom.length === 0) {
    personData.mainCustom[0] = {};
    personData.mainCustom[0].customerEmpty = true;
    personData.mainCustom[0].data = {};
  } else {
    personData.mainCustom[0].customerEmpty = false;
  }

  const clientBusPartners = personData?.clientBusPartner;

  if (Array.isArray(clientBusPartners) && clientBusPartners.length === 0) {
    personData.clientBusPartner[0] = {};
    personData.clientBusPartner[0].clientBusPartnerEmpty = true;
    personData.clientBusPartner[0].data = {};
  } else {
    personData.clientBusPartner[0].clientBusPartnerEmpty = false;
  }

  const otherClientPoliticsPosition =
    personData?.clientPoliticsPosition?.[0]?.data?.clientPoliticOther;

  if (
    otherClientPoliticsPosition &&
    typeof otherClientPoliticsPosition === "string" &&
    otherClientPoliticsPosition !== "0"
  ) {
    personData.clientPoliticsPosition[0].data.clientPoliticOtherInput = otherClientPoliticsPosition;
    personData.clientPoliticsPosition[0].data.clientPoliticOther = true;
  }

  const mainClientAdress = personData?.clientAddress[0]?.data;
  const secondaryClientAdress = personData?.clientAddress[1]?.data;

  if (mainClientAdress && secondaryClientAdress) {
    const adressKeys = Object.keys(mainClientAdress);
    let matchingKeys = 0;
    const keysToMatch = ["addressCity", "addressCountry", "addressPostCode", "addressStreet"];

    adressKeys.forEach(key => {
      if (mainClientAdress[key] === secondaryClientAdress[key] && keysToMatch.includes(key))
        matchingKeys++;
    });

    if (matchingKeys === keysToMatch.length) {
      personData.clientAddress[0].clientSameRealAddress = true;
    }
  }

  const businessGroup = personData?.clientBasicBusiness?.[0]?.data?.clientBasicBusiness;

  if (businessGroup) {
    const [section, chapter] = businessGroup.split('.');
    if (section && chapter) {
      personData.clientBasicBusiness[0].data.clientBasicBusinessMainGroups = `${section}.${chapter}`;
    }
  }

  return draftCopy;
};
